module.exports = __webpack_public_path__ + "img/sj1.bb9196a8.png";